module.exports = __webpack_public_path__ + "static/media/user-info-tournament.e8884080.png";